import { Component } from '@angular/core';

@Component({
  selector: 'wsb-error-not-found',
  templateUrl: './error-not-found.component.html',
  styleUrls: ['./error-not-found.component.scss'],
  standalone: false
})
export class ErrorNotFoundComponent {
  constructor() {}
}
